import XCircleIcon from '@heroicons/react/24/outline/XCircleIcon';

export interface FilterBadgeProps {
  onClear: () => void;
  title: string;
}
export const FilterBadge = (props: FilterBadgeProps) => {
  const { onClear, title } = props;
  return (
    <div className='bg-primaryColor-normal rounded-md text-white py-1  px-2 flex justify-between gap-2'>
      <span>{title}</span>
      <XCircleIcon className='h-5 w-5 cursor-pointer hover:text-neutralColor-normal' onClick={onClear} />
    </div>
  );
};
